import { TechProfile } from '../api/carModelsApi';

export function normalizeComparableValue(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function findTechProfileIdByBodyType(
  bodyType: string,
  techProfiles: TechProfile[],
  bodyTypeLabel?: string
): string | undefined {
  const comparableValues = [bodyType, bodyTypeLabel]
    .filter((value): value is string => Boolean(value))
    .map(normalizeComparableValue);

  return techProfiles.find((profile) =>
    comparableValues.includes(normalizeComparableValue(profile.name))
  )?.id;
}
